module.exports = __webpack_public_path__ + "media/pin-on-image.b8225d64.webm";